export default __webpack_public_path__ + "14a4a6d30cd1815f767835456995643b.obj";